// 结果页
const drinkPlan = [
  {
    type: '上午',
    data: [
      {
        time: '7:00 - 8:00',
        cup: 1
      },
      {
        time: '9:00 - 10:00',
        cup: 1
      },
      {
        time: '11:00 - 11:30',
        cup: 1
      }
    ]
  },
  {
    type: '下午',
    data: [
      {
        time: '13:00 - 13:30',
        cup: 1
      },
      {
        time: '14:30 - 15:30',
        cup: 1
      },
      {
        time: '16:00 - 17:30',
        cup: 1
      }
    ]
  },
  {
    type: '晚上',
    data: [
      {
        time: '18:00 - 19:00',
        cup: 1
      },
      {
        time: '20:00 - 21:00',
        cup: 1
      }
    ]
  }
]

export { drinkPlan }
